import { DesktopContent, MobileContent } from 'src/design-system'
import { observer } from 'mobx-react-lite'
import { Toaster } from 'react-hot-toast'
import * as React from 'react'
import { MobileSideNav } from './mobile-side-nav'
import { SideNavContent } from './side-nav-content'
import { SideNavProvider } from './side-nav-context'
import { SideNavErrorBoundary } from './side-nav-error-boundary'
import { useStore } from 'store/context'

export const SideNav = observer(() => {
  const { currentUser, positions, teams, orgs, bootstrapping } = useStore()

  React.useEffect(() => {
    // Wait for bootstrap to complete before fetching data
    // This prevents a flood of API requests right after bootstrap
    if (bootstrapping) return

    positions.fetchAll({
      include: ['team', 'disciplines', 'team.org', 'skills', 'salaries'],
      page: { size: 9999 },
    })
  }, [positions, bootstrapping])

  React.useEffect(() => {
    // Wait for bootstrap to complete before fetching data
    // This prevents a flood of API requests right after bootstrap
    if (bootstrapping) return

    orgs.fetchAll()
    teams.fetchAll({
      include: [
        'editors',
        'framework.disciplines',
        'framework',
        'open_positions',
        'users',
      ],
      page: { size: 9999 },
    })
  }, [teams, orgs, bootstrapping])

  if (!currentUser) return null

  return (
    <>
      <SideNavProvider>
        <Toaster
          containerClassName="print-hide"
          toastOptions={{
            style: {
              borderRadius: '0.25rem',
              maxWidth: '500px',
            },
          }}
        />
        <nav id="side-nav">
          <DesktopContent className="print-hide">
            <SideNavErrorBoundary>
              <SideNavContent />
            </SideNavErrorBoundary>
          </DesktopContent>
          <MobileContent className="print-hide">
            <SideNavErrorBoundary>
              <MobileSideNav />
            </SideNavErrorBoundary>
          </MobileContent>
        </nav>
      </SideNavProvider>
    </>
  )
})
